import Button from '../components/Button';
import Callout from '../components/Callout';
import Content from '../components/Content';
import ServiceList from '../components/ServiceList';
import './Services.scss';

const LIST_SERVICES = [
    {
        title: '👩‍💻  Web Development',
        description: "From static sites to WordPress builds to full-stack Next.js apps, we’ve got your back. Whether you just need a quick refresh or want help choosing the right tools from scratch, we’ll meet you where you are—and get you where you want to go.",
    },
    {
        title: '📱  Web & Mobile Applications',
        description: "Need something custom? We build intuitive, reliable applications for the web and mobile—tailored to your community, your goals, and your values. Whether you're dreaming up a grassroots organizing tool or a community-first app, we'll help you make it real."
    },
    {
        title: '🖌️  UX & UI Design',
        description: "Design isn't just how it looks—it's how it works, and how it feels. We craft user experiences that are accessible, thoughtful, and grounded in your mission. From wireframes to final polish, we center your audience every step of the way."
    },
    {
        title: '📊  Data Analysis',
        description: "Your data holds stories—about impact, growth, and where to go next. We help you understand and visualize those stories, making complex data approachable and useful. From spreadsheets to dashboards, we translate numbers into strategy."
    },
    {
        title: '🎨  Graphic Design',
        description: "From flyers to infographics to full brand identities, we make visuals that speak your language. We’ll work closely with you to create bold, clear, and expressive designs that reflect your values and connect with your community."
    },
    {
        title: '📢  Marketing',
        description: "You shouldn’t have to compromise your values to reach your people. We offer mission-aligned marketing strategies that center authenticity, community, and care. From social media to email campaigns, we help you get the word out—without selling out."
    }
]

const LIST_CLIENTS = [
    {
        imageURL: 'CulturehouseInverse.svg',
        title: 'Culturehouse',
        url: 'https://culturehouse.cc'
    },
    {
        imageURL: 'PePoInverse.svg',
        title: 'Panethnic Pourovers',
        url: 'https://panethnicpourovers.org'
    },
    {
        imageURL: 'WinnableServicesInverse.svg',
        title: 'Winnable',
        url: 'https://winnable.app'
    },
    {
        imageURL: 'ABB.svg',
        title: 'Ashley Bryant Bailey',
        url: 'https://ashleyforohio.com/'
    }
]

const Services = () => {
    return (
        <div className='services-page'>
            <section className="page">
                <div className='container'>
                    <Callout
                        title='We make things from the ground up.'
                        eyebrow='How do we build?'
                        description='We build relationships, then we build products.'
                    />
                </div>
                <Content heading='We create solutions that last.'>
                    <ServiceList 
                        serviceItems={LIST_SERVICES}
                    />
                </Content>
                <Content heading='Clients' variation='inverse'>
                    <div className='client-grid'>
                        {LIST_CLIENTS.map((client) => 
                            <a href={client.url} target='_blank'>
                                <img src={`/clients/${client.imageURL}`} width={150} alt={client.title}/>
                            </a>
                        )}
                    </div>
                </Content>
                <Content>
                    <div className='container-small'>
                        <center>
                        <h2>Need something fast, simple, and affordable? Our starter sites can be built in as quickly as 48 hours.</h2>
                        <p><Button label='Learn More' goTo='/starter' variation='secondary'/></p>
                        </center>
                    </div>
                </Content>
            </section>
        </div>
    )
}

export default Services;